import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as o2Api from "../../../../../api/api";
import "src/scss/grid-styles.scss";
import StoreListWhere from "../../../where/StoreListWhere";
import {Loading} from "../../../../../components/common";
import {currencyFormatter} from "../../../../../config/formatter";
import * as formatter from "../../../../../config/formatter";
import {gridColumnSum} from "../../../../../config/common";
import StoreCornerListWhere from "../../../where/StoreCornerListWhere";

const {RangePicker} = DatePicker;

const CardApprSaleReport = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const [gridData, setGridData] = useState([]);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({
		cmpCd: "", brandCd: "", storeCd: "", cornerCd: "",
		fromSaleDt: dayjs(), toSaleDt: dayjs()
	});

	const defaultColDef = {
		width: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [columnDefs] = useState([
		{field: "No", headerName: "NO", hide: true, minWidth: 100},
		{field: "storeCd", headerName: "매장코드", minWidth: 80},
		{field: "storeNm", headerName: "매장명", minWidth: 80, cellStyle: {color: "blue", cursor: "pointer"}},
		{
			headerName: "전체", children: [
				{
					field: "totalBillCnt",
					headerName: "총건수",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				},
				{
					field: "totalReqPayAmt",
					headerName: "요청금액",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				},
				{
					field: "totalPayAmt",
					headerName: "승인금액",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				}
			]
		},
		{
			headerName: "승인", children: [
				{
					field: "billCnt",
					headerName: "총건수",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				},
				{
					field: "reqPayAmt",
					headerName: "요청금액",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				},
				{
					field: "payAmt",
					headerName: "승인금액",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				}
			]
		},
		{
			headerName: "취소", children: [
				{
					field: "rejectBillCnt",
					headerName: "총건수",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				},
				{
					field: "rejectReqPayAmt",
					headerName: "요청금액",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				},
				{
					field: "rejectPayAmt",
					headerName: "승인금액",
					minWidth: 80,
					valueFormatter: formatter.currencyFormatter,
					cellClass: "number-cell"
				}
			]
		}
	]);

	useEffect(() => {

	}, []);

	const onGridReady = useCallback((params) => {

	}, []);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
            }));
        }
    };

	const search = () => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd} = props.selected;

		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
			toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
		};

		props.setLoading(true);
		o2Api.getCardApprSale(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				props.setLoading(false);
				setGridData(responseBody);
				createStatTotalRowData(responseBody);
			}
		});
	};

	const createStatTotalRowData = (data) => {
		const api = gridRef.current.api;
		const result = [];
		result.push({
			storeNm: "합계",
			totalBillCnt: gridColumnSum(data, 'totalBillCnt'),
			totalReqPayAmt: gridColumnSum(data, 'totalReqPayAmt'),
			totalPayAmt: gridColumnSum(data, 'totalPayAmt'),
			billCnt: gridColumnSum(data, 'billCnt'),
			reqPayAmt: gridColumnSum(data, 'reqPayAmt'),
			payAmt: gridColumnSum(data, 'payAmt'),
			rejectBillCnt: gridColumnSum(data, 'rejectBillCnt'),
			rejectReqPayAmt: gridColumnSum(data, 'rejectReqPayAmt'),
			rejectPayAmt: gridColumnSum(data, 'rejectPayAmt')
		});
		api.setPinnedBottomRowData(result);
	};

	const onCellClicked = (e) => {
		console.log("e ::: ", e);

		const {cmpCd, brandCd, storeCd} = e.data;

		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = "cmpCd=" + cmpCd + "&brandCd=" + brandCd + "&storeCd=" + storeCd
			+ "&fromSaleDt=" + searchForm.fromSaleDt.format("YYYYMMDD") + "&toSaleDt=" + searchForm.toSaleDt.format("YYYYMMDD")
		;
		console.log("params:: ", params);

		console.log("e.colDef.field ::", e.colDef.field);

		switch (e.colDef.field) {
			case "storeNm":
				//if (e.value > 0) {
				window.open('/#/sale/appr/card?' + params + '&type=', "_pay", "width=900, height=700");
				//}
				break;
		}
	};


	/*Start 화면 그리드 영역*/
	return (
		<>
			<div style={containerStyle}>
				{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
				<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
									  onSelect={(c, v) => handleSelect(c, v)}/>
				<div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
					<CCol xs={12} md={6}>
						<CInputGroup size="sm">
							<CInputGroupText style={{width: 100}}>조회일자</CInputGroupText>
							<CInputGroupText style={{background: "white", height: 35}}>
								<RangePicker bordered={false}
											 separator={"~"}
											 placeholder={""}
											 locale={locale}
											 value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
											 onChange={(dayjs, dateString) => {
												 setSearchForm((state) => ({
													 ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
												 }));
											 }}/>
							</CInputGroupText>
						</CInputGroup>
					</CCol>
					<div className={"d-grid d-lg-flex gap-1"}>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"}
								 onClick={search}>조회</CButton>
					</div>
                </div>

				<div style={{height: 10}}/>
				<div className="ag-theme-alpine" style={{width: "100%", height: 480, marginTop: 10}}>
					<AgGridReact
						ref={gridRef}
						onGridReady={onGridReady}
						rowSelection={"single"}
						onCellClicked={onCellClicked}
						headerHeight={30}
						rowHeight={30}
						rowData={gridData}
						animateRows={true}
						enableRangeSelection={true}
						enableCellTextSelection={true}
						suppressClipboardPaste={true}
						localeText={{noRowsToShow: "조회 결과가 없습니다."}}
						defaultColDef={defaultColDef}
						columnDefs={columnDefs}>
						<AgGridColumn field="sales" aggFunc="sum"/>
					</AgGridReact>
				</div>
			</div>
		</>
	); //End 화면 그리드


} //End CardApprSaleReport


const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(CardApprSaleReport);

